import { createSvgIcon } from '@mui/material';

export const DocIcon = createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.98432 12.9286L11.5399 12.9286V11.5397L5.98432 11.5397V12.9286ZM5.98432 10.1508L11.5399 10.1508V8.76189L5.98432 8.76189V10.1508ZM4.59543 15.7063C4.21349 15.7063 3.88652 15.5703 3.61453 15.2983C3.34254 15.0264 3.20654 14.6994 3.20654 14.3174L3.20654 3.20633C3.20654 2.82439 3.34254 2.49742 3.61453 2.22543C3.88652 1.95344 4.21349 1.81744 4.59543 1.81744L10.151 1.81744L14.3177 5.98411L14.3177 14.3174C14.3177 14.6994 14.1817 15.0264 13.9097 15.2983C13.6377 15.5703 13.3107 15.7063 12.9288 15.7063L4.59543 15.7063ZM9.45654 6.67856V3.20633L4.59543 3.20633L4.59543 14.3174L12.9288 14.3174L12.9288 6.67856L9.45654 6.67856Z"
      fill="currentColor"
    />
  </svg>,
  'DocIcon',
);
